<template>
  <b-container>
    <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items"/>

    <b-table small outlined striped hover :items="form_items" :fields="form_fields">
      <template v-slot:cell(index)="data">
        {{data.index+1}}
      </template>

      <template v-slot:cell(account_type)="data">
        <b-form-select
            v-model="data.item.account_type"
            :options="account_type_options"
          />
      </template>

      <template v-slot:cell(username)="data">
        <b-form-input type="text" required placeholder v-model="data.item.username"></b-form-input>
      </template>

      <template v-slot:cell(password)="data">
        <b-form-input type="text" required placeholder v-model="data.item.password" :disabled="(data.item.id)"></b-form-input>
      </template>

      <template v-slot:cell(name)="data">
        <b-form-input type="text" required placeholder v-model="data.item.name"></b-form-input>
      </template>

      <template v-slot:cell(phone)="data">
        <b-form-input type="text" required placeholder v-model="data.item.phone"></b-form-input>
      </template>
    </b-table>

    <b-button type="button" variant="primary" @click="addFormRow()">Add Row</b-button>

    <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>

    <br><br>
  </b-container>
</template>

<script>
const account_type_options = [
  {
    value: "admin",
    text: "Admin"
  },
  {
    value: "cs",
    text: "CS"
  },
  {
    value: "logistic",
    text: "Logistic"
  },
  {
    value: "driver",
    text: "Driver"
  },
  {
    value: "young_living",
    text: "Client - Young Living - CS"
  },
  {
    value: "young_living_logistic",
    text: "Client - Young Living - Logistic"
  }
];

export default {
  name: "UserEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  data() {
    return {
      account_type_options : account_type_options,
      breadcrumb_items: [
        {
          text: "Users",
          to: { name: "users" }
        },
        {
          text: "Manage Users",
          active: true
        }
      ],

      form_fields: [
        {
          key: "index",
          label: "#"
        },
        {
          key: "account_type",
          label: "Account Type"
        },
        {
          key: "username",
          label: "Username"
        },
        {
          key: "password",
          label: "Password"
        },
        {
          key: "name",
          label: "User Name"
        },
        {
          key: "phone",
          label: "Phone"
        }
      ],
      form_items: [
      ]
    };
  },

  async created() {
    await this.getUsers();
    this.addFormRow();
  },
  methods : {
    addFormRow (){
      this.form_items.push({
          username : '',
          password: '',
          name : '',
          phone: '',
          account_type: 'admin'
        });
    },
    submitForm(){
      this.addUsers();
    },

    async getUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_get.php",
        data: {
          limit: 99999
        }
      });
      this.form_items = response.data.users;
    },

    async addUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_bulk.php",
        data: {
          users : this.form_items
        }
      });

      if (response.data.status == "success") {
        this.$router.go(-1);
      } else {
        alert("something goes wrong...");
      }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/UserManage.vue